export default __webpack_public_path__ + "static/nh_bank-0fb5e5161cbcb6830e0741463af8f8bd.jpg";